import { __extends } from "tslib";
import { async } from '../scheduler/async';
import { isValidDate } from '../util/isDate';
import { Subscriber } from '../Subscriber';
import { lift } from '../util/lift';
export function delay(delay, scheduler) {
    if (scheduler === void 0) { scheduler = async; }
    var delayFor = isValidDate(delay) ? +delay - scheduler.now() : Math.abs(delay);
    return function (source) { return lift(source, new DelayOperator(delayFor, scheduler)); };
}
var DelayOperator = (function () {
    function DelayOperator(delay, scheduler) {
        this.delay = delay;
        this.scheduler = scheduler;
    }
    DelayOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DelaySubscriber(subscriber, this.delay, this.scheduler));
    };
    return DelayOperator;
}());
var DelaySubscriber = (function (_super) {
    __extends(DelaySubscriber, _super);
    function DelaySubscriber(destination, delay, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        _this.delay = delay;
        _this.scheduler = scheduler;
        _this.queue = [];
        _this.active = false;
        return _this;
    }
    DelaySubscriber.dispatch = function (state) {
        var source = state.source;
        var queue = source.queue;
        var scheduler = state.scheduler;
        var destination = state.destination;
        while (queue.length > 0 && queue[0].time - scheduler.now() <= 0) {
            destination.next(queue.shift().value);
        }
        if (queue.length > 0) {
            var delay_1 = Math.max(0, queue[0].time - scheduler.now());
            this.schedule(state, delay_1);
        }
        else if (source.isStopped) {
            source.destination.complete();
            source.active = false;
        }
        else {
            this.unsubscribe();
            source.active = false;
        }
    };
    DelaySubscriber.prototype._schedule = function (scheduler) {
        this.active = true;
        var destination = this.destination;
        destination.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
            source: this,
            destination: destination,
            scheduler: scheduler,
        }));
    };
    DelaySubscriber.prototype._next = function (value) {
        var scheduler = this.scheduler;
        var message = new DelayMessage(scheduler.now() + this.delay, value);
        this.queue.push(message);
        if (this.active === false) {
            this._schedule(scheduler);
        }
    };
    DelaySubscriber.prototype._error = function (err) {
        this.queue.length = 0;
        this.destination.error(err);
        this.unsubscribe();
    };
    DelaySubscriber.prototype._complete = function () {
        if (this.queue.length === 0) {
            this.destination.complete();
        }
        this.unsubscribe();
    };
    return DelaySubscriber;
}(Subscriber));
var DelayMessage = (function () {
    function DelayMessage(time, value) {
        this.time = time;
        this.value = value;
    }
    return DelayMessage;
}());
//# sourceMappingURL=delay.js.map